export class CompanyContactInfo {
  CompanyContactID: number
  CompanyCode: string
  CompanyName: string
  CompanyContactCode: string
  CompanyContactName: string
  CompanyContactTel: string
  CompanyContactEmail: string
  CompanyContactFax: string
  CompanyContactCreateDate: string
  CompanyContactCreateBy: string
  CompanyContactCreateByName: string
  CompanyContactUpdateDate: string
  CompanyContactUpdateBy: string
  CompanyContactUpdateByName: string
  rowOFFSet: number
  rowFetch: number
  itemTotal: number
}
